import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Script from "next/script";
import { FC, Fragment } from "react";
import ThankYou from "~/components/ThankYou";
import Trans from "~/types/translationKeys";

export const getServerSideProps: GetServerSideProps = async (context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale || "en", ["common"])),
    },
  };
};

const ThankYouPage: FC = () => {
  return (
    <Fragment>
      {/* <Script
        src="https://apis.google.com/js/platform.js?onload=renderBadge"
        async
        defer
      ></Script>

      <Script id="google-badge">
        {`
          window.renderBadge = function() {
            var ratingBadgeContainer = document.createElement("div");
            document.body.appendChild(ratingBadgeContainer);
            window.gapi.load('ratingbadge', function() {
              window.gapi.ratingbadge.render(ratingBadgeContainer, {"merchant_id": 5484568668});
            });
          }
        `}
      </Script>
      <Script id="gooogle-survey">
        {`
          window.renderOptIn = function() {
          window.gapi.load('surveyoptin', function() {
            window.gapi.surveyoptin.render(
              {
                // REQUIRED FIELDS
                "merchant_id": 5484568668,
                "order_id": "ORDER_ID",
                "email": "CUSTOMER_EMAIL",
                "delivery_country": "COUNTRY_CODE",
                "estimated_delivery_date": "YYYY-MM-DD",

                // OPTIONAL FIELDS
                "products": [{"gtin":"GTIN1"}, {"gtin":"GTIN2"}]
              });
          });
        }
        `}
      </Script> */}
      <ThankYou
        title={Trans.ltd_thank_you_title}
        description={Trans.ltd_thank_you_desc}
      />
    </Fragment>
  );
};

export default ThankYouPage;
